import { render, staticRenderFns } from "./DigitalGuru.vue?vue&type=template&id=59123127&"
import script from "./DigitalGuru.vue?vue&type=script&lang=js&"
export * from "./DigitalGuru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports